export default "__VITE_ASSET__41372158__"